import { BsHandThumbsDown } from "react-icons/bs"; 
import { TbClipboardCheck } from "react-icons/tb"; 
import { BsHandThumbsUp } from "react-icons/bs";
import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
import CxButton from '../../cx/CxButton';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxDlgAlert from '../../cx/CxDlgAlert';
import * as FxLog from '../../fx/FxLog';
import '../../../styles/main.css';
import { StoreSettEmail } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import * as FxFetch from '../../fx/FxFetch';
import CxDialog from '../../cx/CxDialog';
import { getStoreValue } from "../../gx/GxStore";
import CxSnackbar from '../../cx/CxSnackbar';
import CxState from '../../cx/CxState';


const MxSettCommEmailForm = (props) => {
  const [{ trans }] = useTranslation();

  let r_form = React.useRef(null);
  const r_snack_error = React.useRef(null);

  const r_dlg_test = React.useRef(null);
  const r_dlg_test_result = React.useRef(null);

  const rf_test_txEmail = React.useRef('');
  const rf_txName = React.useRef(null);
  const rf_txUser = React.useRef(null);
  const rf_txPassword = React.useRef(null);

  const [storeSettEmail, setStoreSettEmail] = useSessionStorage('StoreSettEmail', StoreSettEmail);
  const [dlgTest, setDlgTest] = React.useState(false);

  const [, updateState] = React.useState();
  const forceUIUpdate = React.useCallback(() => updateState({}), []);
  

  // Corregido por Gemini - 18/03/2026
  React.useEffect(() => {
    if (dlgTest) {
      const strSavedEmail = localStorage.getItem('MxSettCommEmailForm.txEmailTest');
      
      // Usamos un intervalo pequeño o aseguramos que la ref existe
      const timer = setTimeout(() => {
        if (strSavedEmail && rf_test_txEmail.current) {
          // Verificamos si tiene el método setVal antes de llamar
          if (typeof rf_test_txEmail.current.setVal === 'function') {
            rf_test_txEmail.current.setVal(strSavedEmail);
          }
        }
      }, 150); // Aumentamos ligeramente el delay para el render del CxDialog

      return () => clearTimeout(timer);
    }
  }, [dlgTest]);

  const formLoad = async (data) => {
    if (data === null) { //nuevo registro
      let txLang = getStoreValue('StoreSession', 'txLocale').substring(0,2);
      FxLog.infox('MxSettCommEmailForm.formLoad', '...txLang', txLang);
      switch (txLang) {
        case 'en':
          rf_txName.current.setVal('My e-mail account');
          break;
  
        case 'es':
          rf_txName.current.setVal('Mi cuenta e-mail');
          break;
  
        default:
          break;
      }
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus === 'error') {
      if (lastSaveRv.theValue==='rv_name_exists') r_snack_error.current.setValAndOpen(trans('msg.existing_x','field.name'));
      if (lastSaveRv.theValue==='rv_default_needed') r_snack_error.current.setValAndOpen(trans('msg.default_x_required','field.account'));
    } else {
      storeSettEmail.itEmail = lastSaveRv.theValue;
      Promise.all([setStoreSettEmail(storeSettEmail)]).then((result) => {
        //navBack(); // 2024-05-15 - daq: nos quedamos, por si el usuario quiere hacer una prueba.
        forceUIUpdate();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  const doGmail = () => {
    let props = "";
    props += "mail.smtp.host=smtp.gmail.com\n";
    props += "mail.smtp.port=587\n";
    props += "mail.smtp.auth=1\n";
    props += "mail.smtp.ssl.trust=*\n";
    props += "mail.smtp.starttls.enable=true\n";
    r_form.current.getRef(`t_email.txProps`).setVal(props);
  };

  /*
  const doOutlook = () => {
    let props = "";
    props += "mail.smtp.host=smtp.office365.com\n";
    props += "mail.smtp.port=587\n";
    props += "mail.smtp.auth=1\n";
    props += "mail.smtp.ssl.trust=*\n";
    props += "mail.smtp.starttls.enable=true\n";
    r_form.current.getRef(`t_email.txProps`).setVal(props);
  };
  */

  const doIberical = () => {
    let record = {};
    record['idValue'] = getStoreValue('StoreSession', 'inBranch');
    Promise.all([FxFetch.doJsonX('sett/branches/r', record)]).then((result) => {
      if (result[0]) {
        let txCompany = result[0][0].txCompany;
        let txEmail = result[0][0].txEmail;

        let props = "";
        props += "mail.smtp.host=mail.iberical.com\n";
        props += "mail.smtp.port=465\n";
        props += "mail.smtp.auth=true\n";
        props += "mail.smtp.ssl.trust=*\n";
        props += "mail.smtp.starttls.enable=false\n";
        props += "mail.smtp.socketFactory.port=465\n";
        props += "mail.smtp.socketFactory.class=javax.net.ssl.SSLSocketFactory\n";
        props += "mail.smtp.ssl.protocols=TLSv1.2\n";

        if (txEmail) props += `ibs.reply-to=${txEmail}\n`;
        if (txCompany) props += `ibs.visible-name=${txCompany}\n`;
        r_form.current.getRef(`t_email.txProps`).setVal(props);
        rf_txUser.current.setVal('service@iberical.com');
        rf_txPassword.current.setVal('NGC5866');
      }
    });
    
  };

  const doTest = () => {
    try {
      setDlgTest(false);
      let txEmail = rf_test_txEmail.current.getVal();
      if (!txEmail) {
        localStorage.removeItem('MxSettCommEmailForm.txEmailTest', txEmail);
      } else {
        // Guardar email en localstorage para la proxima vez
        localStorage.setItem('MxSettCommEmailForm.txEmailTest', txEmail);

        let record = {};
        record['itEmail'] = storeSettEmail.itEmail; // cuenta remitente
        record['txEmail'] = txEmail; // email destinatario
        Promise.all([FxFetch.doJsonX(`sett/email/test`, record)]).then((result) => {
          if (result[0]?.theValue === 'OK') {
            r_dlg_test_result.current.setText(trans('msg.operation_successful'));
            r_dlg_test_result.current.setTextColor('var(--ibs_color_green)');
            r_dlg_test_result.current.setIcon(<BsHandThumbsUp fontSize="30px" style={{ fill: 'var(--ibs_color_green)', paddingBottom: '10px' }} />);
          } else {
            FxLog.infox('MxSettCommEmailForm.doTest', '...result[0]:', result[0]);
            r_dlg_test_result.current.setText(result[0]?.theDesc || 'TIMEOUT');
            r_dlg_test_result.current.setTextColor('var(--ibs_color_red)');
            r_dlg_test_result.current.setIcon(<BsHandThumbsDown fontSize="30px" style={{ fill: 'var(--ibs_color_red)', paddingBottom: '10px' }} />);
          }
          r_dlg_test_result.current.setOpen(true);
        });
      }

    } catch (error) {
      FxLog.errorx("MxSettCommEmailForm.doTest", error);
    }
  };

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.comms')}: ${trans('field.email')}`}
        xref={r_form}
        url="sett/email"
        filterIdField='itEmail'
        filterIdValue={storeSettEmail.itEmail}
        onFormLoad={formLoad}
        onFormSave={formSave}
        onFormDelete={formDelete}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {storeSettEmail.itEmail && <CxIconButtonNew icon={<TbClipboardCheck fontSize="24px" style={{paddingTop:'0px'}} />} classType="ibs_iconbutton_toolbar" onClick={() => setDlgTest(true)} tooltip={trans('field.test')} />}
          </div>
        }
      >
        <CxHidden xref={useRef(null)} dbfield="t_email.itEmail" value={storeSettEmail.itEmail || ''} />
        <CxInput xref={rf_txName} label={trans('field.name')} dbfield="t_email.txName" required maxLength={50} />
        <CxInput xref={rf_txUser} label={trans('field.user')} dbfield="t_email.txUser" maxLength={50} />
        <CxInput xref={rf_txPassword} label={trans('field.password')} dbfield="t_email.txPass" type="password" maxLength={50} />
        <CxInput xref={useRef(null)} dbfield="t_email.txProps" minRows={10} />
        <div style={{ width: '100%', textAlign: 'left', display: 'flex', flexDirection: 'row', flexFlow: 'row wrap', gap: '5px' }}> {/* línea separada */}
          <CxState mode='checkbox' xref={useRef(null)} label={trans('field.default_0')} dbfield="t_email.boDefault" />
        </div>
        <div style={{ width: '100%', textAlign: 'left', display: 'flex', flexDirection: 'row', flexFlow: 'row wrap', gap: '5px' }}> {/* línea separada */}
          <CxButton label={'GMail'} onClick={doGmail} />
          {/* <CxButton label={'Outlook'} onClick={doOutlook} /> */}
          <CxButton label={'Iberical'} onClick={doIberical} />
        </div>
      </GxForm>

      <CxDialog
        xref={r_dlg_test}
        title={`${trans('field.addressee')} (${trans('field.email')})`}
        open={dlgTest}
        onOk={doTest}
        onCancel={() => setDlgTest(false)}
        height='200px'>

        <CxInput xref={rf_test_txEmail} width="var(--ibs_control_width_md)" />
      </CxDialog>

      <CxDlgAlert xref={r_dlg_test_result} hasButtonClose />

      <CxSnackbar xref={r_snack_error} severity="error" />

    </div>
  );

}

export default MxSettCommEmailForm;
